import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './CollapsibleIcon.module.scss';

const CollapsibleIcon = ({ collapsed, color = null }) => {
  return (
    <span className={styles['collapsible-icon']} aria-hidden="true">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="24"
          cy="24"
          r="24"
          className={classNames(styles['collapsible-icon__circle'], {
            [styles['collapsible-icon__circle--collapsed']]: collapsed,
            [styles['collapsible-icon__circle--expanded']]: !collapsed
          })}
          style={{ fill: color || undefined }}
        />
        {collapsed ? (
          <g>
            <rect x="15.5" y="23" width="17" height="2" rx="1" fill="#000" />
            <rect x="23" y="15.5" width="2" height="17" rx="1" fill="#000" />
          </g>
        ) : (
          <rect x="15.5" y="23" width="17" height="2" rx="1" fill="#fff" />
        )}
      </svg>
    </span>
  );
};

CollapsibleIcon.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  color: PropTypes.string
};

export default CollapsibleIcon;
